<div *ngIf="messageForm" class="container">
  <div [ngSwitch]="chatType">
    <ng-container *ngSwitchCase="CHART_TYPE.GENERIC">
      <app-chat-input-file-upload
        [accept]="appConstants.ACCEPTED_FILE_FORMATS_FILES"
        (onFileSelected)="onSelectedFiles($event)"
      >
        <ng-container *ngTemplateOutlet="textContainerTemp"></ng-container>
      </app-chat-input-file-upload>
    </ng-container>
    <ng-container *ngSwitchCase="CHART_TYPE.ASSISTANT">
      <app-chat-input-file-upload-assistant
        [acceptSearchFiles]="appConstants.ACCEPTED_FILE_FORMATS_FILES"
        [acceptInterpreterFiles]="appConstants.ACCEPTED_FILE_FORMATS_CODE_INTERPRETERS"
        (fileDropSearchFiles)="updateFiles($event)"
        (fileDropInterpreterFiles)="updateCodeInterpreterFiles($event)"
      >
        <ng-container *ngTemplateOutlet="textContainerTemp"></ng-container>
      </app-chat-input-file-upload-assistant>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngTemplateOutlet="textContainerTemp"></ng-container>
    </ng-container>
  </div>
  <div class="d-flex align-items-center justify-content-center">
    <p class="text-center">Answers generated by AI may be incorrect.</p>
    <div class="my-auto ms-2">
      <i class="pi pi-info-circle me-1 cursor-pointer" pTooltip="About AI Portal" (click)="goToAboutPage()"></i>
      <p-button
        *ngIf="showContactUsIcon"
        icon="pi pi-envelope"
        [rounded]="true"
        (onClick)="openReportIssueDialog()"
        pTooltip="Contact us or report issue"
      ></p-button>
    </div>
  </div>
</div>

<ng-template #textContainerTemp>
  <div class="text-container">
      <div class="d-flex">
        <div class="p-inputgroup">
          <textarea
            #textArea
            id="chat-textarea"
            class="text-area"
            pInputTextarea
            [formControl]="messageForm"
            (keydown.enter)="$event.preventDefault(); send()"
            [rows]="1"
            placeholder="Type your question..."
          ></textarea>
          <div *ngIf="isAssistant()" class="button-with-indicator">
            <div class="button-wrapper">
              <p-button
                icon="pi pi-paperclip"
                (onClick)="showFilesDialog()"
                [pTooltip]="'Attach files to prompt'"
                [text]="true"
              ></p-button>
              <!--                    TODO: use   p-overlaybadge from PrimeNG 18-->
              <span
                *ngIf="
                  messageFileItems.length + messageCodeInterpreterFiles.length >
                  0
                "
                class="file-count-indicator"
                >{{
                  messageFileItems.length + messageCodeInterpreterFiles.length
                }}</span
              >
            </div>
          </div>
          <p-button
            [icon]="
              aiTypingResponse
                ? 'fa-regular fa-hand'
                : 'fa-regular fa-paper-plane'
            "
            (onClick)="handleActionButton()"
            [disabled]="!aiTypingResponse && !messageForm.valid"
            [pTooltip]="aiTypingResponse ? 'Stop generating' : 'Send message'"
          ></p-button>
        </div>
      </div>
      <div *ngIf="hasInputValueErrors">
        <small class="p-error"
          >Please enter at least 3 non-whitespace characters</small
        >
      </div>
    </div>
</ng-template>

<p-dialog
  header="Prompt Files"
  [(visible)]="displayFilesDialog"
  [modal]="true"
  [style]="{ width: '65%' }"
>
  <div class="d-flex mb-3">
    <i class="pi pi-info-circle me-1"></i>
    <div>
      Selected files are attached to single prompt (message). To attach files to
      whole context of your conversation, click on Settings click on upper right
      corner of the chat.
    </div>
  </div>
  <app-chat-assistant-files
    title="File search"
    [files]="messageFileItems"
    (onFilesChange)="updateFiles($event)"
    [acceptedFiles]="appConstants.ACCEPTED_FILE_FORMATS_FILES"
  ></app-chat-assistant-files>
  <app-chat-assistant-files
    title="Code interpreters"
    [files]="messageCodeInterpreterFiles"
    (onFilesChange)="updateCodeInterpreterFiles($event)"
    [acceptedFiles]="appConstants.ACCEPTED_FILE_FORMATS_CODE_INTERPRETERS"
  ></app-chat-assistant-files>
  <div class="d-flex justify-content-end">
    <div>
      <p-button
        label="Delete all"
        severity="secondary"
        icon="pi pi-times"
        (onClick)="deleteAllFiles()"
      />
      <p-button
        label="Confirm"
        icon="pi pi-check"
        (onClick)="displayFilesDialog = false"
      />
    </div>
  </div>
</p-dialog>
